<template>
  <div>
    <div v-if="!commonData" class="examples">
      <a-spin />
    </div>
    <div v-else class="home-banner">
      <div class="home-navlist">
        <div class="navlist-posi">
          <div class="logo-img">
            <img
              v-if="commonData.web_logo && commonData.web_logo.value"
              :src="commonData.web_logo.value" alt="logo">
          </div>
          <div class="nav-list">
            <div class="open-icon" @click="openMenu = true">
              <div><!-- icon --></div>
              <div><!-- icon --></div>
              <div><!-- icon --></div>
            </div>
            <div class="open-icon-close" v-if="openMenu">
              <a-icon type="close" @click="openMenu = false" />
            </div>
            <ul :class="{'open-ul' : openMenu}">
              <!-- 暂时用用下面的数据，因为客户暂时不用资讯页面 -->
              <li :class="{'sele' : !ind}" v-for="(item, ind) in navList" :key="ind"
                v-show="item.label_zh !== 'News'"
                @click="$router.push(item.value)">{{item.label_zh}}</li>
                <li class="skipStyle">
                  <span @click="switchZhong" class="cur-p primary">中文</span><span class="segmentation">|</span><span class="cur-p zwcolor">ENGLISH</span>
                </li>
            </ul>
          </div>
          <div class="banner-info" v-if="data.length">
            <p class="title">{{data[seleBannerIndex].slider_title}}</p>
            <p class="minifont to-3">{{data[seleBannerIndex].slider_sub_title}}</p>
            <a-button class="fo-min-btn mt-30" @click="goToPage(data[seleBannerIndex].slider_link_url)">{{data[seleBannerIndex].slider_button_text}}</a-button>
          </div>
        </div>
        <div class="ywdp"><span @click="switchZhong" class="cur-p hoverColor">中文</span><span class="segmentation">|</span><span class="cur-p zwcolor">ENGLISH</span></div>
      </div>
      <a-carousel autoplay :afterChange="afterChangeHandle">
        <div class="banner-bg centerimage"
          v-for="(item, ind) in data"
          :key="ind"
          :style="'background-image: url(' + item.slider_image_url + ');'">
        </div>
      </a-carousel>
      <!-- 下滑指引 -->
      <div class="s-line"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: mapGetters([
    'commonData'
  ]),
  data () {
    return {
      openMenu: false,
      seleBannerIndex: 0,
      navList: [],
      data: [],
      cond: {
        page_num: 1,
        page_size: 6
      }
    }
  },
  watch: {
    'commonData.web_pages' (obj) {
      this.navList = JSON.parse(obj.value)
    }
  },
  mounted () {
    this.readList()
    if (this.commonData.web_pages.value) {
      this.navList = JSON.parse(this.commonData.web_pages.value)
    }
  },
  methods: {
    switchZhong () {
      window.location.href = 'https://www.rongyinglaw.com/zh/#/home'
    },
    goToPage (router) {
      window.open(router)
    },
    readList () {
      this.get({
        url: 'slideRead',
        data: this.cond
      }, (res) => {
        this.data = res.data.items
      })
    },
    afterChangeHandle (va) {
      if (va >= 0) {
        this.seleBannerIndex = va
      }
    }
  }
}
</script>

<style lang="less">
@import url('../../utils/color.less');
/* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
  .examples {
    text-align: center;
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 170px 50px;
    margin: 20px 0;
  }
  .home-banner {
    .skipStyle {
      padding-top: 36px !important;
    }
    .segmentation {
      padding-left: 10px;
      padding-right: 10px;
    }
    overflow: hidden;
    width: 100%;
    height: 400px;
    position: relative;
    background-color: @primary;
    .banner-bg {
      width: 100%;
      height: 100%;
    }
    /* 轮播图样式修正 */
    .slick-slider,
    .slick-list,
    .slick-track {
      height: 100%;
    }
    /* 右下角小图标修正 */
    .ant-carousel {
      height: 100%;
      .slick-slide {
        text-align: center;
        height: 100%;
        line-height: 300px;
        background: #364d79;
        overflow: hidden;
        > div {
          height: 100%;
        }
      }
      .slick-dots {
        width: 100%;
        position: relative;
        height: 8px;
        margin: auto;
        text-align: center;
        bottom: 26px;
        li {
          margin-left: 10px;
        }
        button {
          width: 6px;
          height: 6px;
        }
        li.slick-active {
          button {
            width: 20px;
          }
        }
      }
    }
    /* 左侧导航样式 */
    .home-navlist {
      .ywdp {
        display: none;
      }
      .ywxp {
        font-family: Georgia, 宋体;
        position: absolute;
        left: 180px;
        top: -23px;
        width: 100px;
        padding-top: 20px;
        color: #fff;
        font-size: 18px;
        text-align: right;
        margin-right: 60px;
      }
      .navlist-posi {
        .logo-img {
          position: absolute;
          z-index: 2;
          left: 16px;
          top: 16px;
          img {
            width: 120px;
            height: 28px;
          }
        }
        .nav-list {
          .open-icon {
            width: 30px;
            position: absolute;
            z-index: 2;
            right: 16px;
            top: 16px;
            div {
              height: 4px;
              width: 100%;
              border-radius: 2px;
              margin-bottom: 5px;
              background-color: @support;
            }
          }
          .open-icon-close {
            position: absolute;
            z-index: 10;
            font-size: 16px;
            right: 22px;
            top: 16px;
          }
          ul {
            width: 200px;
            height: 100%;
            color: @silver;
            background-color: #FFF;
            font-size: 16px;
            padding: 60px 0 20px;
            position: absolute;
            z-index: 9;
            right: -200px;
            transition: 0.3s;
            -webkit-transition: 0.3s;
            margin: 0;
          }
          ul.open-ul {
            right: 0;
          }
          li {
            font-family: Georgia, 宋体;
            list-style-type: none;
            padding: 8px 0;
            text-align: center;
          }
          li.sele,
          li:hover {
            color: @primary;
            background: @primarylight;
          }
          li:hover {
            background: @op-primary02;
          }
        }
        .banner-info {
          color: #FFF;
          font-family: Georgia, 宋体 !important;
          padding: 0 16px;
          position: absolute;
          z-index: 2;
          bottom: 50px;
          left: 0;
          .title {
            font-weight: 600;
            font-size: 28px;
            margin: 0;
          }
          .minifont {
            font-size: 14px;
            padding-top: 10px;
            margin: 0;
          }
        }
      }
    }
  }
}
/* 大于 750 */
@media screen and (min-width: 751px) {
  .examples {
    text-align: center;
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 320px 50px;
    margin: 20px 0;
  }
  @width: 80%;
  @maxWidth: 1400px;
  /* logo顶部、按钮底部间距 */
  @topBottomSpace: 40px;
  .home-banner {
    .skipStyle {
      display: none !important;
    }
    .segmentation {
      padding-left: 20px;
      padding-right: 20px;
    }
    .hoverColor:hover {
      color: #DBA77F;
    }
    .zwcolor {
      color: rgba(255, 255, 255, 0.5) !important;
    }
    width: 100%;
    height: calc(100vh - 30px);
    min-height: 650px;
    max-height: 700px;
    position: relative;
    background-color: @primary;
    .banner-bg {
      width: 100%;
      height: 100%;
    }
    /* 轮播图样式修正 */
    .slick-slider,
    .slick-list,
    .slick-track {
      height: 100%;
    }
    /* 右下角小图标修正 */
    .ant-carousel {
      height: 100%;
      .slick-slide {
        text-align: center;
        height: 100%;
        line-height: 300px;
        background: #364d79;
        overflow: hidden;
        > div {
          height: 100%;
        }
      }
      .slick-dots {
        width: @width;
        max-width: @maxWidth;
        position: relative;
        height: 8px;
        margin: auto;
        text-align: right;
        bottom: @topBottomSpace;
        li {
          margin-left: 10px;
        }
        button {
          width: 8px;
          height: 8px;
        }
        button.slick-active {
          width: 40px;
        }
      }
    }
    /* 左侧导航样式 */
    .home-navlist {
      .ywxp {
        display: none;
      }
      .ywdp {
        font-family: Georgia, 宋体;
        padding-top: 30px;
        color: #fff;
        font-size: 16px;
        text-align: right;
      }
      width: @width;
      max-width: @maxWidth;
      height: calc(100% - @topBottomSpace);
      margin: auto;
      position: absolute;
      z-index: 2;
      right: 0;
      left: 0;
      .navlist-posi {
        width: 1126px;
        height: calc(100% + @topBottomSpace);
        background: @op-primary06;
        position: absolute;
        /*left: -1017px;*/
        right: calc(100% - 270px);
        top: 0;
        .logo-img {
          padding: @topBottomSpace 0 30px;
          img {
            position: absolute;
            z-index: 999;
            left: 850px;
            top: 30px;
            width: 200px;
            height: 44px;
          }
        }
        .nav-list {
          color: #FFF;
          font-size: 16px;
          position:  relative;
          top:  34px;
          li {
            font-family: Georgia, 宋体;
            list-style-type: none;
            padding: 8px 0;
            cursor: pointer;
            -webkit-user-select: none;
            -moz-user-select: none;
          }
          li.sele,
          li:hover {
            color: @support;
            background: @primary;
          }
          li:hover {
            background: @op-primary02;
          }
        }
        .banner-info {
          color: #FFF;
          font-family: Georgia, 宋体 !important;
          padding-bottom: 40px;
          position: absolute;
          bottom: 0;
          left: 0;
          .title {
            font-weight: 600;
            line-height: 46px;
            font-size: 48px;
            white-space:nowrap;
            margin: 0;
          }
          .minifont {
            font-size: 14px;
            padding-top: 20px;
            letter-spacing: 1px;
          }
        }
        .logo-img,
        .nav-list li,
        .banner-info {
          padding-left: 76%;
        }
      }
    }
    .s-line {
      display: block;
      width: 2px;
      height: 40px;
      border-radius: 2px;
      position: absolute;
      left: 50%;
      margin-left: -1px;
      bottom: -20px;
      background: @support;
    }
    .s-line {
      animation: a_banner_s_line 3s 0.3s linear both infinite;
      -webkit-animation: a_banner_s_line 3s 0.3s linear both infinite;
      -ms-animation: a_banner_s_line 3s 0.3s linear both infinite;
      -moz-animation: a_banner_s_line 3s 0.3s linear both infinite;
      -o-animation: a_banner_s_line 3s 0.3s linear both infinite;
    }
    /*动画*/
    @keyframes a_banner_s_line {
      0%{ transform:scale(1,1);-webkit-transform:scale(1,1);-ms-transform:scale(1,1);-moz-transform:scale(1,1);-o-transform:scale(1,1); transform-origin:50% 100%;-webkit-transform-origin:50% 100%;-ms-transform-origin:50% 100%;-moz-transform-origin:50% 100%;-o-transform-origin:50% 100%; opacity: 1;}
      20%{ transform:scale(1,0.01);-webkit-transform:scale(1,0.01);-ms-transform:scale(1,0.01);-moz-transform:scale(1,0.01);-o-transform:scale(1,0.01); transform-origin:50% 100%;-webkit-transform-origin:50% 100%;-ms-transform-origin:50% 100%;-moz-transform-origin:50% 100%;-o-transform-origin:50% 100%; opacity: 1;}
      30%{ transform:scale(1,0.01);-webkit-transform:scale(1,0.01);-ms-transform:scale(1,0.01);-moz-transform:scale(1,0.01);-o-transform:scale(1,0.01); transform-origin:50% 100%;-webkit-transform-origin:50% 100%;-ms-transform-origin:50% 100%;-moz-transform-origin:50% 100%;-o-transform-origin:50% 100%; opacity: 0;}
      31%{ transform:scale(1,0.01);-webkit-transform:scale(1,0.01);-ms-transform:scale(1,0.01);-moz-transform:scale(1,0.01);-o-transform:scale(1,0.01); transform-origin:50% 0;-webkit-transform-origin:50% 0;-ms-transform-origin:50% 0;-moz-transform-origin:50% 0;-o-transform-origin:50% 0; opacity: 0;}
      50%{  transform:scale(1,1);-webkit-transform:scale(1,1);-ms-transform:scale(1,1);-moz-transform:scale(1,1);-o-transform:scale(1,1); transform-origin:50% 0;-webkit-transform-origin:50% 0;-ms-transform-origin:50% 0;-moz-transform-origin:50% 0;-o-transform-origin:50% 0; opacity: 1;}
      100%{  transform:scale(1,1);-webkit-transform:scale(1,1);-ms-transform:scale(1,1);-moz-transform:scale(1,1);-o-transform:scale(1,1); transform-origin:50% 100%;-webkit-transform-origin:50% 100%;-ms-transform-origin:50% 100%;-moz-transform-origin:50% 100%;-o-transform-origin:50% 100%; opacity: 1;}
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/banner.vue